import React from 'react';
import { Controller } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import LabelName from 'components/UI/LabelName/LabelName';

function EventDescription({ control }) {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12">
        <LabelName required={false} htmlFor="description">
          Description
        </LabelName>
      </div>
      <div className="col-md-8 col-12">
        <Controller
          name="description"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <InputTextarea id={field.name} {...field} rows={4} className="w-100" placeholder="Enter event description..." autoResize />
          )}
        />
      </div>
    </div>
  );
}

export default EventDescription;
